import React from 'react';

const  GameLoader = () => {
    return (<div className="skeleton-wrapper">
        <div className="skeleton-card"></div>
        <div className="skeleton-card"></div>
        <div className="skeleton-card"></div>
        <div className="skeleton-card"></div>
        <div className="skeleton-card"></div>
    </div>)
}

export default GameLoader;